<p-toast></p-toast>

<div class="card p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
    <div class="field md:col-12 col-12">

        <div class="statedata">
            <ul>
                <li class="tank-subsidy">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i>{{ 'Subsidy Disbursed (Tank) (₹): '}}
                        &nbsp;</strong>
                    <span class="counter">{{ totalSubsidyDisbursedTank | number }}</span> &nbsp;Cr.
                </li>
                <li class="pdmc-subsidy">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i>{{ 'Subsidy Disbursed (PDMC) (₹): '}}
                        &nbsp;</strong>
                    <span class="counter">{{ totalSubsidyDisbursedPDMC | number }}</span> &nbsp;Cr.
                </li>
                <li class="total-subsidy">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> {{ 'Total Subsidy Disbursed (₹): '}}
                        &nbsp;</strong>
                    <span class="counter">{{ totalSubsidyDisbursed | number }}</span> &nbsp;Cr.
                </li>
            </ul>
        </div>
    </div>
    <!-- </div>

<div class="card p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap"> -->

    <div *ngIf="tankSubsidyChartData" class="field md:col-4 col-12">
        <div class="pie-district-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy
                    Disbursed (Tank)'
                    }}</label>
            </div>
            <p-chart #pieChart type="pie" [data]="tankSubsidyChartData" [options]="options" width="250" height="250"
                (onDataSelect)="onClickPie($event, 'Tank')"></p-chart>
        </div>
    </div>

    <div *ngIf="PDMCSubsidyChartData" class="field md:col-4 col-12">
        <div class="pie-district-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy
                    Disbursed (PDMC) '
                    }}</label>
            </div>
            <p-chart #pieChart type="pie" [data]="PDMCSubsidyChartData" [options]="options" width="250" height="250"
                (onDataSelect)="onClickPie($event, 'PDMC')"></p-chart>
        </div>
    </div>

    <div *ngIf="subsidyDisSumYearwise" class="field md:col-4 col-12">
        <div class="pie-district-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Total Subsidy
                    Disbursed'
                    }}</label>
            </div>
            <p-chart #pieChart type="pie" [data]="subsidyChartData" [options]="options" width="250" height="250"
                (onDataSelect)="onClickPie($event, '')"></p-chart>
        </div>
    </div>
</div>

<div #lotDataTable *ngIf="lotNoByFinYear.length > 0" class="dashboardTable card">
    <p-table #lotTable [value]="lotNoByFinYear" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'Lot_No',
        'total_apps',
        'total_centre_share',
        'total_state_share',
        'total_topup',
        'total_aby',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'black', 'background-color': 'rgb(167, 164, 164)'}">
                <!-- Left side -->
                <div class="col-12 md:col-6">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ tableHeader | translate}}</h5>
                </div>

                <!-- Middle section for buttons -->
                <div class="col-12 md:col-2 d-flex justify-content-center">
                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                        placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>

                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="lotTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="miUnderProcessReport"></p-menu>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}</th>
                <th pSortableColumn="Lot_No">{{'LOT_NO'| translate}}</th>
                <th pSortableColumn="total_apps">{{'Total Apps'| translate}}</th>
                <th>{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                <th>{{'STATE_SHARE_AMOUNT'| translate}}</th>
                <th>{{'TOP_UP_AMOUNT'| translate}}</th>
                <th>{{'ABY_AMOUNT'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-ri="rowIndex">
            <tr class="body-section">
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{ ri + 1 }}</td>
                <td class="clickable-text" (click)="onClickLotNo(item)">{{item?.Lot_No}}</td>
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{item?.total_apps}}</td>
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{item?.total_centre_share}}</td>
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{item?.total_state_share}}</td>
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{item?.total_topup}}</td>
                <td class="cursor-pointer" (click)="onSelectRow(item)">{{item?.total_aby}}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">

        </ng-template>

    </p-table>
</div>

<div #lotDetailsTable *ngIf="lotDetails.length > 0" class="dashboardTable card">
    <p-table #lotTable [value]="lotDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'Lot_No',
        'AppID',
        'PFMSPaymentDate',
        'Centre_share_amt',
        'State_share_amt',
        'TopUp',
        'aby',
        'Status',
        'Remarks',
        'CAORemarks',
        'Fin_Year',
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Lot_No"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'white', 'background-color': 'grey'}">
                <!-- Left side -->
                <div class="col-12 md:col-6">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'white'}">{{ 'Lot No '}} {{ selectedLotNo }}
                        {{'details' }}</h5>
                </div>

                <!-- Middle section for buttons -->
                <div class="col-12 md:col-2 d-flex justify-content-center">
                    <!-- <label class="pr-2">{{ 'User Filter' }}</label>
                    <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                        placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
                </div>

                <!-- Right side for search -->
                <div class="col-12 md:col-4 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="lotTable.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="lotDetailReport"></p-menu>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}</th>
                <th pSortableColumn="AppID">{{'APP_ID'| translate}}</th>
                <th>{{'PFMS_PAYMENT_DATE'| translate}}</th>
                <th>{{'CENTER_SHARE_AMOUNT'| translate}}</th>
                <th>{{'STATE_SHARE_AMOUNT'| translate}}</th>
                <th>{{'TOP_UP_AMOUNT'| translate}}</th>
                <th>{{'ABY_AMOUNT'| translate}}</th>
                <th>{{'STATUS'| translate}}</th>
                <th>{{'REMARKS'| translate}}</th>
                <th>{{'CAO_REMARKS'| translate}}</th>
                <th>{{'FINANCIAL_YEAR'| translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item let-ri="rowIndex">
            <tr class="body-section">
                <td>{{ ri + 1 }}</td>
                <td class="clickable-text" (click)="onClickApp(item.AppID)">{{item?.AppID}}</td>
                <td>{{item?.PFMSPaymentDate | date:'mediumDate'}}</td>
                <td>{{item?.Centre_share_amt}}</td>
                <td>{{item?.State_share_amt}}</td>
                <td>{{item?.TopUp}}</td>
                <td>{{item?.aby}}</td>
                <td>{{item?.Status}}</td>
                <td>{{item?.Remarks}}</td>
                <td>{{item?.CAORemarks}}</td>
                <td>{{item?.Fin_Year}}</td>
            </tr>
        </ng-template>

        <ng-template pTemplate="footer">

        </ng-template>

    </p-table>
</div>

<p-dialog [(visible)]="showLotDataDialog" [modal]="true" [style]="{ width: '100%', height: '100%' }"
    [maximizable]="true" [draggable]="false" [resizable]="false" (onHide)="hideDialog()">
    <div class="mi-survey-container">
        <div class="card dashboardTable">
            <p-table #miSurvey [value]="lotData" [rows]="10" [paginator]="true" [globalFilterFields]="[
                    'Farmer_Name_In_English',
                    'Full_Name_in_Recognized_Official_Language',
                    'Caste_Description',
                    'Gender',
                    'Address_Line_1',
                    'Address_Line_2',
                    'Address_Line_3',
                    'District',
                    'State', 
                    'Country', 
                    'Farmer_Bank_Name', 
                    'Farmer_IFSCCode',
                    'Farmer_Account_Number', 
                    'Aadhar_Number', 
                    'Pincode', 
                    'Scheme_Specific_Id',
                    'Center_Share_Payment_Amount', 
                    'State_Share_Payment_Amount', 
                    'Remarks',
                    'ChallanNo',
                    'UTR',
                    'CreditDateTime',
                    'Programme_Name',
                    'UserType',
                    'Applicant_Type',
                    'MIArea',
                    'CAORemarks',
                    'TopUp',
                    'Total_Area',
                    'Crop_Name',
                    'FarmerType',
                    'Block',
                    'Village',
                    'ABY'
                    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO' | translate}} {last} {{'OF' | translate}} {totalRecords} {{'ENTRIES' | translate}}"
                [showCurrentPageReport]="true" [loading]="loading1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_SUBSIDY_TO_FARMER_LOT'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH' | translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID' | translate}}
                            <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Name_In_English">{{'FULL_NAME_IN_ENGLISH' | translate}}
                            <p-columnFilter type="text" field="Farmer_Name_In_English" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Farmer_Name_In_English"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Full_Name_in_Recognized_Official_Language">
                            {{'FULL_NAME_IN_RECOGNIZED_OFFICIAL_LANGUAGE' | translate}}
                            <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">
                            {{'CASTE' | translate}}
                            <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Gender">{{'GENDER' | translate}}
                            <p-columnFilter type="text" field="Gender" display="menu"></p-columnFilter>
                            <p-sortIcon field="Gender"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_1">{{'ADDRESSLINE1' | translate}}
                            <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_2">{{'ADDRESSLINE2' | translate}}
                            <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_3">{{'ADDRESSLINE3' | translate}}
                            <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'Village' | translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT' | translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State">{{'STATE' | translate}}
                            <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                            <p-sortIcon field="State"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Country">{{'COUNTRY' | translate}}
                            <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                            <p-sortIcon field="Country"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerType">{{'FARMER_TYPE' | translate}}
                            <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Bank_Name">{{'FARMER_BANK_NAME' | translate}}
                            <p-columnFilter type="text" field="Farmer_Bank_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Bank_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_IFSCCode">{{'FARMER_IFSCCODE' | translate}}
                            <p-columnFilter type="text" field="Farmer_IFSCCode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_IFSCCode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Account_Number">{{'FARMER_ACCOUNT_NUMBER' | translate}}
                            <p-columnFilter type="text" field="Farmer_Account_Number" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Farmer_Account_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER' | translate}}
                            <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pincode">{{'PINCODE' | translate}}
                            <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pincode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ChallanNo">{{'CHALLAN_NO' | translate}}
                            <p-columnFilter type="text" field="ChallanNo" display="menu"></p-columnFilter>
                            <p-sortIcon field="ChallanNo"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UTR">{{'UTR' | translate}}
                            <p-columnFilter type="text" field="UTR" display="menu"></p-columnFilter>
                            <p-sortIcon field="UTR"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CreditDateTime">{{'CREDITED_DATE' | translate}}
                            <p-columnFilter type="text" field="CreditDateTime" display="menu"></p-columnFilter>
                            <p-sortIcon field="CreditDateTime"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT' | translate}}
                            <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp">{{'TOP_UP' | translate}}
                            <p-columnFilter type="text" field="TopUp" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="TopUp"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ABY">{{'ABY' | translate}}
                            <p-columnFilter type="text" field="ABY" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="ABY"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Programme_Name">{{'PROGRAMME_NAME' | translate}}
                            <p-columnFilter type="text" field="Programme_Name" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Programme_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Crop_Name">{{'CROP_NAME' | translate}}
                            <p-columnFilter type="text" field="Crop_Name" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Crop_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                            <p-columnFilter type="text" field="UserType" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="UserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Applicant_Type">{{'APPLICATION_TYPE' | translate}}
                            <p-columnFilter type="text" field="Applicant_Type" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Applicant_Type"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MIArea">{{'MIAREA' | translate}}
                            <p-columnFilter type="text" field="MIArea" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Area">{{'TOTAL_LAND_HOLDING' | translate}}
                            <p-columnFilter type="Total_Area" field="Total_Area" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Remarks">{{'REMARKS' | translate}}
                            <p-columnFilter type="text" field="Remarks" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Remarks"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CAORemarks">{{'CAO_REMARKS' | translate}}
                            <p-columnFilter type="text" field="CAORemarks" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="CAORemarks"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <!-- <td>
                                <button pButton pRipple pTooltip="{{'VIEW_APPLICATION' | translate}}" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectFarmerApplication(product)"></button>
                            </td> -->
                        <td class="clickable-text" (click)="onClickApp(product?.Scheme_Specific_Id)">
                            {{product?.Scheme_Specific_Id}}</td>
                        <td>{{product?.Farmer_Name_In_English}}</td>
                        <td>{{product?.Full_Name_in_Recognized_Official_Language}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product?.Gender}}</td>
                        <td>{{product?.Address_Line_1}}</td>
                        <td>{{product?.Address_Line_2}}</td>
                        <td>{{product?.Address_Line_3}}</td>
                        <td>{{product?.Village}}</td>
                        <td>{{product?.Block}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.State}}</td>
                        <td>{{product?.Country}}</td>
                        <td>{{product?.FarmerType}}</td>
                        <td>{{product?.Farmer_Bank_Name}}</td>
                        <td>{{product?.Farmer_IFSCCode}}</td>
                        <td>{{product?.Farmer_Account_Number}}</td>
                        <td>{{product?.Aadhar_Number}}</td>
                        <td>{{product?.Pincode}}</td>
                        <td>{{product?.ChallanNo}}</td>
                        <td>{{product?.UTR}}</td>
                        <td>{{product?.CreditDateTime}}</td>
                        <td>{{product?.Center_Share_Payment_Amount}}</td>
                        <td>{{product?.State_Share_Payment_Amount}}</td>
                        <td>{{product?.TopUp}}</td>
                        <td>{{product?.ABY}}</td>
                        <td>{{product?.Programme_Name}}</td>
                        <td>{{product?.Crop_Name}}</td>
                        <td>{{product?.UserType}}</td>
                        <td>{{product?.Applicant_Type}}</td>
                        <td>{{product?.MIArea}}</td>
                        <td>{{product?.Total_Area}}</td>
                        <td>{{product?.Remarks}}</td>
                        <td>{{product?.CAORemarks}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{lotData ? lotData.length : 0 }}
                        {{'MI_SUBSIDY_TO_FARMER_LOT_APPLICATIONS_ADDED'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-dialog>